import React from "react";
import { Tooltip, Button } from "antd";
import { DeleteOutlined, DeleteFilled } from '@ant-design/icons';
import { disabledColor, peerColor } from "../../utils/Utils";
import { apiCall } from "../../utils/Api";

export default function ListTrash(props) {

    const { list = {}, results = {}, setResults = () => { } } = props;
    const { list_id = "", is_trashed = false } = list;

    const toggleListTrash = (is_picked) => {

        apiCall("titlelist/trash", { list_id: list_id, is_picked: is_picked }, (_status, _result) => {
            if (_status) {
                let newArr = { ...results };
                let update = results.rows.find(item => item.list_id === _result.list_id);
                update.is_trashed = _result.is_trashed;
                newArr.rows[results.rows.findIndex(item => item.list_id === _result.list_id)] = update;
                setResults({ ...results, "rows": newArr.rows })
            }
        });

    }

    return (
        <Tooltip title="Trash this List/Catalogue internally so it is no longer Featured or kept in any other folder.">
            <div onClick={() => toggleListTrash(!is_trashed)}>
                <Button size="small" type="link" icon={(!is_trashed) ? <DeleteOutlined style={{ "color": disabledColor }} /> : <DeleteFilled style={{ "color": peerColor }} />} />
            </div>
        </Tooltip>
    );


}